import { SidebarMenuStyled } from './SidebarMenuStyled';
import { useEffect } from 'react';
import Link from '../Link/Link';

const SidebarMenu = ({ links, open, onScroll }) => {
  useEffect(() => {
    const closeMenu = () => {
      onScroll();
    };

    if (open) {
      window.addEventListener('scroll', closeMenu, { passive: true });
    } else {
      window.removeEventListener('scroll', closeMenu);
    }

    return () => window.removeEventListener('scroll', closeMenu);
  }, [open, onScroll]);

  return (
    <SidebarMenuStyled open={open}>
      <ul>
        {links.map((link) => {
          return (
            <li key={link.path}>
              <Link {...link} />
            </li>
          );
        })}
      </ul>
    </SidebarMenuStyled>
  );
};

export default SidebarMenu;
